import React, { useState } from 'react'
import SnowMountain from '../imgs/SnowMountain1.mp4';
import Paraglide from '../imgs/Paragliding1.mp4';
import Scuba from '../imgs/Scuba1.mp4';
import About2 from  '../imgs/About2.jpg';
import back1 from  '../imgs/back-3.png';
import back2 from  '../imgs/back-4.png';
import back3 from  '../imgs/back2.png';








const AboutUs = () => {

    return (
        <section className='section-about' id='section-about'>  

            <div className='about'>
            <div className='book'>

            <input type='checkbox' className='c' id='c1'/>
            <input type='checkbox' className='c' id='c2'/>
            <input type='checkbox' className='c' id='c3'/>
            <div id='cover' className='cover'>
            <video className='bg-video__content zero' autoPlay muted loop>
                <source src={SnowMountain} type='video/mp4'/>
                Your browser is not supported
                </video>
            </div>

            <div className='flip-book'>
            <div className='flip' id='p1'>
                <div className='back'>
                <video className='bg-video__content first' autoPlay muted loop>
                <source src={Paraglide} type='video/mp4'/>
                Your browser is not supported
                </video>
                    <label className='back-btn' for='c1'>Back</label>

                </div>
            <div className='front'>
                <h2 className='heading-primary--main primary-1'>Winter Holidays<span className='heading-primary--main primary-2'>You Dream About </span> </h2>
                <p className='detail'>Lorem ipsum dolor sit amet. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
              <img src={back1} className='back-1'/>
                <label for='c1' className='next-btn'>Next</label>




            </div>
            </div>
            <div className='flip' id='p2'>
                <div className='back'>
                <video className='bg-video__content second' autoPlay muted loop>
                <source src={Scuba} type='video/mp4'/>
                Your browser is not supported
                </video>
                    <label className='back-btn' for='c2'>Back</label>

                </div>
            <div className='front'>

                <h2 className='heading-primary--main primary-1'>Take Every Risk.<span className='heading-primary--main primary-2'> Drop Every Fear.</span><span className='heading-primary--main primary-1'>And Skydive.</span></h2>
                <p className='detail'>Lorem ipsum dolor sit Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
              <img src={back2} className='back-2'/>

                <label for='c2' className='next-btn'>Next</label>

                


            </div>
            </div>
            <div className='flip' id='p3'>
                <div className='back'>
              
                    <img src={About2} className='third'/>
                    <label className='back-btn' for='c3'>Back</label>

                </div>
            <div className='front'>
                <h2 className='heading-primary--main primary-1'>Best Way To Observe A Fish<span className='heading-primary--main primary-2'> Is To Become A Fish.</span></h2>
                <p className='detail'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
              <img src={back3} className='back-3'/>
                
                <label for='c3' className='next-btn'>Next</label>

                


            </div>
            </div>
            
            
            </div>

            </div>
        
</div> 
           
           
        </section>
    )
}

export default AboutUs
